<template>
  <v-snackbar v-model="show" :color="color" location="top" timeout="3000">
    {{ message }}
  </v-snackbar>
</template>

<script>
export default {
  name: "SnackbarComponent",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "success",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
